import React from 'react';
import PropTypes from "prop-types";
import ReactTooltip from 'react-tooltip';
import DOMPurify from 'dompurify';

const ReactTooltipWrapper = (
  {
    innerHtml = "",
    containerProps = {},
    tooltipProps = {},
    children
  }
) => {
  const sanitizedHTML = DOMPurify.sanitize(innerHtml)

  return (
    <span { ...containerProps }>
      {
        children ? 
        children
        :
        <span dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
      }
      <ReactTooltip { ...tooltipProps }/>
    </span>
  );
};

export default ReactTooltipWrapper;

ReactTooltipWrapper.propTypes = {
  innerHtml: PropTypes.string,
  containerProps: PropTypes.object,
  tooltipProps: PropTypes.object,
  children: PropTypes.object
};
